@if (!readonly) {
    <div class="flex-col">
        <mat-form-field class="flex" [ngClass]="{ 'cb-soft-required': softRequired && !required }">
            <mat-label>{{ label }}</mat-label>
            <textarea
                [id]="inputId"
                class="cb-textarea-field"
                matInput
                [name]="internalName"
                type="text"
                [(ngModel)]="value"
                [required]="required"
                [maxlength]="maxlength || 1000"
                [rows]="rows || 5"
                [disabled]="disabled"
            >
            </textarea>
        </mat-form-field>
        <div class="end-start flex-row">
            <span>{{ getCharCount() }}</span>
        </div>
    </div>
}
@if (readonly) {
    <cb-display-value-new [label]="label">
        @if (value) {
            <div class="flex-row">
                <mat-divider class="cb-margin-right" [vertical]="true"></mat-divider>
                <div style="white-space: pre-line" class="force-wrap flex-col flex">
                    {{ value }}
                </div>
            </div>
        }
        @if (!value) {
            <span class="flex">-</span>
        }
    </cb-display-value-new>
}
